import { createFileRoute } from "@tanstack/react-router";
import { SidebarInset } from "@/components/ui/sidebar";
import { DashboardHeader } from "@/components/dashboard-header";
import { TeamTable } from "@/components/supervisor/team/TeamTable";
import { useFetchSubordinates } from "@/hooks/api/team/useFetchSubordinates";
import PageHeader from "@/components/reusable-components/header/page-header";
import { PaginationComponent } from "@/components/crud/Pagination/Pagination";
import { PAGE_SIZE_OPTIONS } from "@/lib/constants";
import { usePaginationState } from "@/hooks/ui/usePaginationState";

export const Route = createFileRoute("/supervisor/_layout/team")({
  component: TeamPage,
});

function TeamPage() {
  const { page, setPage, pageSize, handlePageSizeChange } =
    usePaginationState();
  const subordinatesQuery = useFetchSubordinates({ page, page_size: pageSize });
  const subordinates = subordinatesQuery.data?.results ?? [];
  const count = subordinatesQuery.data?.count ?? 0;
  const loading = subordinatesQuery.isPending;

  return (
    <SidebarInset>
      <DashboardHeader />
      <div className="space-y-4 p-6 pt-0">
        <PageHeader
          title="My Team"
          description="Everyone who reports to you, directly or indirectly."
        />
        <TeamTable members={subordinates} loading={loading} />
        <PaginationComponent
          count={count}
          page={page}
          onPageChange={setPage}
          isLoading={subordinatesQuery.isFetching}
          pageSize={pageSize}
          onPageSizeChange={handlePageSizeChange}
          pageSizeOptions={PAGE_SIZE_OPTIONS}
        />
      </div>
    </SidebarInset>
  );
}
